// This supports to override the public path of application, for example virtual directory path.
//  In order to override the public path, the hosting page needs to set the path to window.IzendaPublicPath variable.

__webpack_public_path__ = window.IzendaPublicPath || '/';
if (__DEV__) {
  const Perf = require('react-addons-perf');
  window.Perf = Perf;
}

import configJson from 'configJson';
import synergy from '../ui/Izenda.SynergyRoot';

synergy.config(configJson);
synergy.render(document.getElementById('izenda-root'));

export default synergy;



// WEBPACK FOOTER //
// ./app/index.js